/* eslint-disable no-shadow */
import { withStyles, Container } from "@material-ui/core";
import React from "react";
import styles from "./styles";
import { NavLink } from "react-router-dom";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { GoHome } from "react-icons/go";
import { AiOutlineAppstore } from "react-icons/ai";
import { IoIosApps } from "react-icons/io";
import { FaRegNewspaper } from "react-icons/fa";
import { TiNews } from "react-icons/ti";

function BreadcrumbsComponent(props) {
  const { classes, params } = props;
  const renderIcon = item => {
    switch (item.cate) {
      case "project": {
        return <AiOutlineAppstore className={classes.icon} />;
      }

      case "project-child": {
        return <IoIosApps className={classes.icon} />;
      }

      case "news": {
        return <TiNews className={classes.icon} />;
      }

      case "news-child": {
        return <FaRegNewspaper className={classes.icon} />;
      }

      default: {
        return null;
      }
    }
  };

  const renderBreadcrumbs = () => {
    if (params && params.length > 0) {
      return params.map((item, index) => {
        if (index === params.length - 1) {
          return (
            <div key={index} className={classes.lastBreadcrumbs}>
              {renderIcon(item)}
              <span className="content">
                {item.name}
              </span>
            </div>
          );
        } else {
          return (
            <NavLink key={index} className={classes.navLink} to={item.to}>
              {renderIcon(item)}
              {item.name}
            </NavLink>
          );
        }
      });
    }
  };

  return (
    <Container maxWidth="xl">
      <Breadcrumbs aria-label="breadcrumb" className={classes.root}>
        <NavLink key="home" className={classes.navLink} to="/">
          <GoHome className={classes.icon} />
          Trang chủ
        </NavLink>
        {renderBreadcrumbs()}
      </Breadcrumbs>
    </Container>
  );
}

export default withStyles(styles)(BreadcrumbsComponent);
